<template>
  <div v-if="isReady" class="section">
    <div class="content">
      <h1>{{ document.title }}</h1>
    </div>
    <div class="is-margin-bottom">
      <form @submit="gotoSearch">
        <b-field>
          <b-input
            v-model="queryTerm"
            :expanded="true"
            :placeholder='$t("Search...")'
            type="search"
            icon="search"
          ></b-input>
          <p class="control">
            <b-button type="is-primary" @click="gotoSearch">Suchen</b-button>
          </p>
        </b-field>
      </form>
    </div>
    <div>
      <Preview :id="document.id">
        <template #default="{ number, previewImage }">
          <router-link
            :to="{
              name: 'Browser',
              params: { documentId: document.id, pageNum: number },
            }"
          >
            <PreviewImage
              :number="number"
              :source="previewImage"
              :label="`Vorschaubild Seite ${number}`"
            />
          </router-link>
        </template>
      </Preview>
    </div>
  </div>
</template>

<script>
import Preview from "@/components/PagePreview.vue";
import PreviewImage from "@/components/PagePreviewImage.vue";

import Paginated from "@/components/Paginated.vue";

import { createMapper } from "@/utils/mapping.js";

const mapper = createMapper("search-form");

export default {
  components: {
    Preview,
    PreviewImage,
    Paginated,
  },
  head: {
    title() {
      return this.document === null ? null : { inner: this.document.title };
    },
  },
  watch: {
    isReady(value) {
      if (value === true) {
        this.$emit("updateHead");
      }
    },
  },
  data() {
    return {
      document: null,
      queryTerm: "",
      isError: false,
      isReady: false,
    };
  },
  computed: {
    searchQuery() {
      return mapper.toURL({
        term: this.queryTerm,
        titles: [this.document.title]
      });
    },
    searchPageRoute() {
      // FIXME: use from global definition
      return {
        name: "Search",
        query: this.searchQuery,
      };
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.document = await this.api.fetchDocument(
        this.$route.params.documentId
      );
      this.isReady = true;
    },
    gotoSearch() {
      this.$router.push(this.searchPageRoute);
    },
  },
};
</script>


